import { NoopTracker } from "@dpdgroupuk/react-event-tracker";

export default new NoopTracker({
  projectRef: "CULO",
  debug: process.env.NODE_ENV === "development",
});
